class FormCustomizer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }

    init() {
        const waitForElm = (selector) => {
            return new Promise(resolve => {
                if (this.querySelector(selector)) {
                    return resolve(this.querySelector(selector));
                }
        
                const observer = new MutationObserver(mutations => {
                    if (this.querySelector(selector)) {
                        resolve(this.querySelector(selector));
                        observer.disconnect();
                    }
                });
        
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }

        waitForElm('#app-embed').then(() => {
            // Function to attempt to apply styles
            function tryApplyStyles() {
                const appEmbed = document.getElementById('app-embed');
                if (appEmbed && appEmbed.shadowRoot) {
                    const styleElement = document.createElement('style');
                    styleElement.textContent = `
                        form [class^="_dropdownContainer"] {
                            max-height: 200px !important;
                        }
                        @media screen and (max-width: 768px) {
                            form [class^="_optionList"] {
                                max-height: 200px !important;
                            }
                        }
                    `;
        
                    // Append the style element to the shadow root
                    appEmbed.shadowRoot.appendChild(styleElement);
        
                    // Clear the interval as we've successfully applied the styles
                    clearInterval(checkInterval);

                }
            }
        
            // Set an interval to keep checking for the element
            const checkInterval = setInterval(tryApplyStyles, 1000);
        });
        
    }
}

if (!customElements.get('form-customizer')) {
    customElements.define('form-customizer', FormCustomizer);
}